import styled from 'styled-components/macro';

export const DetailsWrapper = styled.div`
  margin-bottom: 24px;
  max-width: 1292px;
  width: 100%;
`;
